import { Typography } from "@mui/material";
import NavigationBar from "../../../../../utils/wizard/navigation";
import PatientForm from "../../../patient/form";
import PatientAutocomplete from "../../../patient/search/Autocomplete";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "../../../../../auth/context";
import { usePatientPhoneRequired } from "../../../../../utils/hooks";

const SurnameInputWithLoading = (props) => {
  const [searchParams] = useSearchParams();
  const patientId = parseInt(searchParams.get("patientId"));

  return (
    <PatientAutocomplete
      patientId={patientId}
      {...props}
    />
  );
};

const MedicalDocumentPatientForm = ({ onFinish, ...props }) => {
  const { user } = useAuth();
  const showShareInfo = user.showPatientShareInfo();
  const phoneRequired = usePatientPhoneRequired();

  const onSubmit = (patient) => {
    onFinish({ patient });
    props.nextStep();
  };

  return (
    <>
      <Typography
        variant="title"
        sx={{ display: "flex", justifyContent: "center", textAlign: "center" }}
      >
        Datos del Paciente
      </Typography>
      <PatientForm onSubmit={onSubmit} SurnameInput={SurnameInputWithLoading} showShareInfo={showShareInfo} phoneRequired={phoneRequired}>
        <NavigationBar {...props} />
      </PatientForm>
    </>
  );
};

export default MedicalDocumentPatientForm;
